import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import axios from 'axios';
import moment from 'moment';
import { authenticationService } from "@/_services";

var user: any;
moment.locale('hr');

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT || 'http://localhost:3000/';
// axios.defaults.timeout = 5000;
axios.defaults.headers['Accept-Language'] = window.localStorage.getItem("dzs.cms.language") || "hr";
// axios.defaults.headers['Authorization'] = 'Bearer ' + window.localStorage.getItem("token");

// Vue.prototype.$http.interceptors.request.use((request)  => {
//   request.headers['Authorization'] = 'Bearer ' + window.localStorage.getItem("token");
//   // next((response) => {
//   //   // if(response.status == 401 ) {
//   //   //   auth.logout();
//   //   //   router.go('/login?unauthorized=1');
//   //   // }
//   // });
// });

Vue.config.productionTip = false;

Vue.use(Buefy);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
